// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB3cGjBxBEY0Kfv6p4IqMhCcloTgnfoUz8",
  authDomain: "disha-rr-smart.firebaseapp.com",
  projectId: "disha-rr-smart",
  storageBucket: "disha-rr-smart.firebasestorage.app",
  messagingSenderId: "449402919681",
  appId: "1:449402919681:web:973ec47c280e94c9669900"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const getFirebaseAuth = () => getAuth(getApp());
export const auth = getAuth(app);
